import { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";

import useLogs from "hooks/logs";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";

import HeaderClientes from "components/_refactor/headers/clients";
import FilterCard from "components/_refactor/filter-card";
import DialogUploadGerarLinkAWS from "./components/dialog-upload";
import TableGerarLinkAWS from "./components/table-gerar-link-aws";
import LoadingData from "components/Loading/LoadingData";
import Snackbar from "components/Alerts/Snackbar";
import InputText from "components/_refactor/text/input";

export default function GerarLinkAWS() {
  const [searching, setSearching] = useState(false);
  const [videoName, setVideoName] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [totalRegisters, setTotalRegisters] = useState(5);
  const [openCreateForm, setOpenCreateForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const { setLocalStorageApiProblem } = useLogs();

  const isMobile = IsMobile();

  const toggleCreateForm = (formType) => {
    if (formType) {
      setOpenCreateForm(formType);
    }
  };

  const handleSearch = async ({ page = 1, sizePerPage = 25 }) => {
    setSearching(true);

    try {
      const res = await Api.get(
        "document-list",
        "conteudo",
        `?page=${page - 1}` +
          `&pageSize=${sizePerPage ? sizePerPage : 25}` +
          `&local=ECO`
      );
      setVideoList(res?.Result?.Documentos || []);
      setTotalRegisters(res?.Result?.TotalRegistro);
      setCurrentPage(page);
      setCurrentSizePerPage(sizePerPage);
    } catch (error) {
      Snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "149",
        screen: "Gerar link AWS",
        problem: `Erro na chamada do endpoint document-list - ${error}`,
      });
    } finally {
      setSearching(false);
    }
  };

  const handleRefresh = async () => {
    setSearching(true);

    return handleSearch({
      page: 1,
      sizePerPage: currentSizePerPage,
    });
  };

  const handleClearFilters = () => {
    setVideoName("");
    setVideoList([]);
  };

  useEffect(() => {
    handleSearch({
      page: 1,
      sizePerPage: currentSizePerPage,
    });
  }, []);

  return (
    <>
      <HeaderClientes section="Gerar Link AWS" subsection="Conteúdo" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={searching}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xs={isMobile ? 12 : 4}>
            <InputText
              label="Título do Vídeo"
              value={videoName}
              onInput={(e) => {
                e.target.value = e.target.value.toString().slice(0, 20);
              }}
              onChange={(e) => {
                setVideoName(e.target.value);
              }}
              disabled={searching}
            />
          </Grid>
        </FilterCard>

        <LoadingData searching={searching} label="Buscando dados..." />
        {!searching && videoList && (
          <TableGerarLinkAWS
            dataTable={videoList}
            totalRegistros={totalRegisters}
            currentPage={currentPage}
            currentSizePerPage={currentSizePerPage}
            toggleCreateForm={toggleCreateForm}
            search={handleSearch}
            searching={searching}
            setSelectedDocument={setSelectedDocument}
            selectedDocument={setSelectedDocument}
          />
        )}
      </Container>
      {Boolean(openCreateForm) && (
        <DialogUploadGerarLinkAWS
          open
          isMobile={isMobile}
          onClose={() => setOpenCreateForm(null)}
          typeForm={openCreateForm}
          selectedRow={selectedDocument}
          refresh={handleRefresh}
        />
      )}
    </>
  );
}
